var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "shopSearch" },
    [
      _c("search-result", {
        attrs: {
          pager: _vm.pager,
          shops: _vm.shops,
          pr_shops: _vm.pr_shops,
          waiting: _vm.form.waiting,
        },
        on: { next: _vm.search },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }